/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { IAbsoluteChartContainerViewProps } from './absolute-chart-container';




export const AbsoluteChartContainerView: React.FC<IAbsoluteChartContainerViewProps> = props => {

    const { 
        row1categories,
        Row1List,
        Row1ListItem,
        row2categories,
        Row2List,
        Row2ListItem,
        row3categories,
        Row3List,
        Row3ListItem,
        row4categories,
        Row4List,
        Row4ListItem,
        row5categories,
        Row5List,
        Row5ListItem,
        row6categories,
        Row6List,
        Row6ListItem,
        row7categories,
        Row7List,
        Row7ListItem,
        row8categories,
        Row8List,
        Row8ListItem,
        row9categories,
        Row9List,
        Row9ListItem,
        row10categories,
        Row10List,
        Row10ListItem,
        columnHeading1,
        columnHeading2,
        columnHeading3,
        columnHeading4,
        columnHeading5
    
    } = props;

    
   


    
    return (
        <table className="sizing product-chart">
            <tr>
            {columnHeading1 ? (
                <th className='table-row'>
                    {columnHeading1}
                </th>
            ) : null}
            {columnHeading2 ? (
                <th className='table-row'>
                    {columnHeading2}
                </th>
            ) : null}
            {columnHeading3 ? (
                <th className='table-row'>
                    {columnHeading3}
                </th>
            ) : null}
            {columnHeading4 ? (
                <th className='table-row'>
                    {columnHeading4}
                </th>
            ) : null}
            {columnHeading5 ? (
                <th className='table-row'>
                    {columnHeading5}
                </th>
            ) : null}
            </tr>

            {row1categories ? (
            <Module {...Row1List}>
                { row1categories.map((row1category: ReactNode, index: number) => {
                    return (
                        <Node {...Row1ListItem} key={index}>
                            {row1category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row2categories ? (
            <Module {...Row2List}>
                { row2categories.map((row2category: ReactNode, index: number) => {
                    return (
                        <Node {...Row2ListItem} key={index}>
                            {row2category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row3categories ? (
            <Module {...Row3List}>
                { row3categories.map((row3category: ReactNode, index: number) => {
                    return (
                        <Node {...Row3ListItem} key={index}>
                            {row3category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row4categories ? (
            <Module {...Row4List}>
                { row4categories.map((row4category: ReactNode, index: number) => {
                    return (
                        <Node {...Row4ListItem} key={index}>
                            {row4category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row5categories ? (
            <Module {...Row5List}>
                { row5categories.map((row5category: ReactNode, index: number) => {
                    return (
                        <Node {...Row5ListItem} key={index}>
                            {row5category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row6categories ? (
            <Module {...Row6List}>
                { row6categories.map((row6category: ReactNode, index: number) => {
                    return (
                        <Node {...Row6ListItem} key={index}>
                            {row6category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row7categories ? (
            <Module {...Row7List}>
                { row7categories.map((row7category: ReactNode, index: number) => {
                    return (
                        <Node {...Row7ListItem} key={index}>
                            {row7category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row8categories ? (
            <Module {...Row8List}>
                { row8categories.map((row8category: ReactNode, index: number) => {
                    return (
                        <Node {...Row8ListItem} key={index}>
                            {row8category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row9categories ? (
            <Module {...Row9List}>
                { row9categories.map((row9category: ReactNode, index: number) => {
                    return (
                        <Node {...Row9ListItem} key={index}>
                            {row9category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            {row10categories ? (
            <Module {...Row10List}>
                { row10categories.map((row10category: ReactNode, index: number) => {
                    return (
                        <Node {...Row10ListItem} key={index}>
                            {row10category}
                        </Node>
                    );
                })}
            </Module>
            ) : null}
            
        </table>

    );
};

export default AbsoluteChartContainerView;
